import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/home/runner/_work/mito-ui/mito-ui/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/runner/_work/mito-ui/mito-ui/layouts/default.vue").then(m => m.default || m)),
  landing: defineAsyncComponent(() => import("/home/runner/_work/mito-ui/mito-ui/layouts/landing.vue").then(m => m.default || m))
}